export default __webpack_public_path__ + "static/media/handy.1f158d2e.png";